import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import { H4 } from 'UIComponents/elements/headings';
import H1 from 'UIComponents/elements/headings/H1';
const StyledH4 = styled(H4).withConfig({
  displayName: "SalesServiceSeatExplainerModal__StyledH4",
  componentId: "sc-1x9sr3o-0"
})(["margin-top:24px;margin-bottom:2px;"]);

const SalesServiceSeatExplainerModal = ({
  handleModalClose,
  productLine
}) => {
  return /*#__PURE__*/_jsxs(UIModal, {
    width: 600,
    use: "conversational",
    children: [/*#__PURE__*/_jsx(UIDialogHeader, {
      children: /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: handleModalClose
      })
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsx(H1, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `upgrades.salesServiceSeatExplainerModal.title.${productLine}`
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'upgrades.salesServiceSeatExplainerModal.description'
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "text-left m-top-8",
        children: [/*#__PURE__*/_jsx(StyledH4, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `upgrades.salesServiceSeatExplainerModal.professional.title.${productLine}`
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `upgrades.salesServiceSeatExplainerModal.professional.description.${productLine}`
          })
        }), /*#__PURE__*/_jsx(StyledH4, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `upgrades.salesServiceSeatExplainerModal.enterprise.title.${productLine}`
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `upgrades.salesServiceSeatExplainerModal.enterprise.description.${productLine}`
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      align: "center",
      children: /*#__PURE__*/_jsx(UIButton, {
        use: "primary",
        onClick: handleModalClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'upgrades.salesServiceSeatExplainerModal.close'
        })
      })
    })]
  });
};

export default SalesServiceSeatExplainerModal;